import { render } from "./TruckList.vue?vue&type=template&id=891a4760&scoped=true"
import script from "./TruckList.vue?vue&type=script&lang=js"
export * from "./TruckList.vue?vue&type=script&lang=js"

import "./TruckList.vue?vue&type=style&index=0&id=891a4760&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-891a4760"

export default script